import { rem } from "@certn/cascadia";
import { mq } from "@certn/cascadia-react";
import { css } from "@emotion/css";

export function useStyles() {
  return {
    container: css(
      mq({
        boxShadow: [undefined, "var(--shadow-card)"],
        marginTop: [0, "var(--space-16)"],
        padding: ["var(--space-0)", "var(--space-6)"],
        borderRadius: [0, "var(--border-radius-3)"],
      }),
      {
        background: "var(--surface-overlay)",
        padding: `${"var(--space-7)"} ${"var(--space-6)"} ${"var(--space-7)"} ${rem(
          "space-6"
        )}`,
        display: "flex",
        textAlign: "center",
        flexDirection: "column",
        gap: `${"var(--space-4)"}}`,
      }
    ),
  };
}
